
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 116 90"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"115","height":"89","x":".5","y":".5","fill":"#FFF","stroke":"#E0E4EC","rx":"4"}}),_c('path',{attrs:{"fill":"#003457","fill-rule":"nonzero","d":"M42.002 24.5l51.5-.063-.004-4-51.5.063z"}}),_c('path',{attrs:{"fill":"#C0C8D7","fill-rule":"nonzero","d":"M42 29.968h34v-2H42z"}}),_c('circle',{attrs:{"cx":"29","cy":"25","r":"6","fill":"#00B7E9"}}),_c('path',{attrs:{"fill":"#003457","fill-rule":"nonzero","d":"M42.002 44.5l51.5-.063-.004-4-51.5.063z"}}),_c('path',{attrs:{"fill":"#C0C8D7","fill-rule":"nonzero","d":"M42 49.968h34v-2H42z"}}),_c('circle',{attrs:{"cx":"29","cy":"45","r":"6","fill":"#00B7E9"}}),_c('path',{attrs:{"fill":"#003457","fill-rule":"nonzero","d":"M42.002 64.5l51.5-.063-.004-4-51.5.063z"}}),_c('path',{attrs:{"fill":"#C0C8D7","fill-rule":"nonzero","d":"M42 69.968h34v-2H42z"}}),_c('circle',{attrs:{"cx":"29","cy":"65","r":"6","fill":"#00B7E9"}})])])
          )
        }
      }
    